import gql from "graphql-tag";

export const DELETE_ITEM_FROM_CALENDAR = gql`
  mutation deleteItemFromCalendar($where: DeleteItemFromCalendar!) {
    deleteItemFromCalendar(where: $where)
  }
`;